import React from "react";
import Resizer from "react-image-file-resizer";
import Moment from "react-moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LoadingBoton } from "../../../../_helpers";
import { ventasService } from "../../../../_services";
import alertService from "../../../../_services/cart/alert.service";

/*
 * Un comprobante es casi siempre una captura del homebanking: texto chico que
 * tiene que quedar legible. Por eso se achica a 1600px y calidad 70 -bastante
 * mas que las fotos de publicacion (1080/50)- y aun asi una captura tipica baja
 * de varios MB a unos pocos cientos de KB, que es lo que importa para no mandar
 * un base64 gigante en el POST.
 */
const LADO_MAXIMO = 1600;
const CALIDAD = 70;

class ComprobanteTransferencia extends React.Component {
  state = {
    subiendo: false,
  };

  inputRef = React.createRef();

  comprimir = (file) =>
    new Promise((resolve, reject) => {
      try {
        Resizer.imageFileResizer(
          file,
          LADO_MAXIMO,
          LADO_MAXIMO,
          "JPEG",
          CALIDAD,
          0,
          (base64) => resolve(base64),
          "base64"
        );
      } catch (e) {
        reject(e);
      }
    });

  onArchivo = async (event) => {
    const file = event.currentTarget.files?.[0];

    // El input se limpia siempre: si no, elegir el mismo archivo dos veces
    // seguidas no dispara el onChange.
    event.currentTarget.value = "";

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alertService.error("El comprobante tiene que ser una imagen");
      return;
    }

    this.setState({ subiendo: true });

    try {
      const base64 = await this.comprimir(file);

      const data = await ventasService.subirComprobante({
        id: this.props.venta.id,
        comprobante: {
          base64: base64,
          descripcion: file.name,
          type: "image/jpeg",
        },
      });

      alertService.msg("Comprobante subido. Le avisamos al vendedor.");
      this.props.onSubido(data.comprobanteUrl);
    } catch (error) {
      alertService.error(error);
    } finally {
      this.setState({ subiendo: false });
    }
  };

  render() {
    const { venta, esVendedor } = this.props;
    const { subiendo } = this.state;
    const url = venta.comprobanteUrl;

    return (
      <div className="comprobante">
        {url && (
          <div className="comprobante__cargado">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="comprobante__preview"
            >
              <img src={url} alt="Comprobante de la transferencia" />
            </a>
            <div className="comprobante__datos">
              <span className="comprobante__estado">
                <FontAwesomeIcon icon="fa-regular fa-circle-check" />
                Comprobante cargado
              </span>
              {venta.comprobanteFecha && (
                <small>
                  <Moment
                    date={venta.comprobanteFecha}
                    format="DD/MM/YYYY HH:mm"
                  />
                </small>
              )}
              <a href={url} target="_blank" rel="noopener noreferrer">
                Ver en tamaño completo
              </a>
            </div>
          </div>
        )}

        {!url && (
          <p className="comprobante__vacio">
            {esVendedor
              ? "El comprador todavía no subió el comprobante de la transferencia."
              : "Cuando hagas la transferencia, subí acá la captura para que el vendedor la vea."}
          </p>
        )}

        {!esVendedor && (
          <div className="comprobante__acciones">
            <label className="button" data-type="primary">
              {subiendo ? "Subiendo" : url ? "Reemplazar" : "Subir comprobante"}
              <LoadingBoton grabando={subiendo} />
              <input
                ref={this.inputRef}
                className="d-none"
                type="file"
                accept="image/png, image/jpeg"
                disabled={subiendo}
                onChange={this.onArchivo}
              />
            </label>
            <small className="comprobante__ayuda">
              La imagen se comprime antes de subirse.
            </small>
          </div>
        )}
      </div>
    );
  }
}

export { ComprobanteTransferencia };
